import { Chip } from "@material-ui/core";
import React from "react";

const color = [
    { id: 1, color: "success" },
    { id: 2, color: "secondary" },
    { id: 3, color: "secondary" },
    { id: 4, color: "primary" },
    { id: 5, color: "deactive" },
]

export default function TicketStatusFormatter({cell, row}) {
    return (
        <Chip
            className={color.find(i => i.id === row.StatusId).color}
            label={cell}
        />
    );
}
